import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';

import TransactionScope from './TransactionScope.layout';


const decorate = compose(withTranslation('transactions'));

export default decorate(TransactionScope);
